require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-update-ويعتبر-برنامج-الشرق-الاوسط-وشمال-افريقيا-في-البنك-الدولي.json") })
        }
      }, "path---ar-eg-update-ويعتبر-برنامج-الشرق-الاوسط-وشمال-افريقيا-في-البنك-الدولي");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-update-ويعتبر-برنامج-الشرق-الاوسط-وشمال-افريقيا-في-البنك-الدولي!./.cache/json/ar-eg-update-ويعتبر-برنامج-الشرق-الاوسط-وشمال-افريقيا-في-البنك-الدولي.json
// module id = 464
// module chunks = 231608221292675